
import { Component, Ref, Vue } from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import FormInput from '@/components/FormInput/FormInput.vue'
import Widget from '@/components/Widget/Widget.vue'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'
import Tenant from '@/models/Tenant'
import SelectOption from '@/models/interface/SelectOption'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import AccessControl from '@/pages/Profile/Components/AccessControl.vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { currencyMask } from '@/models/interface/Masks'

@Component({
  components: {
    FooterNav,
    IconAction,
    FormInput,
    Widget,
    CompanyPicker,
    SelectPicker,
    AccessControl,
    FormWizard,
    TabContent,
  },
})
export default class TenantEdit extends ViewModel {
  @Ref('formWizard') public formWizard!: FormWizard

  public busy: boolean = true

  public loading: boolean = true

  public load_list: boolean = false

  public tenant: Tenant = new Tenant()

  public databases: any = []

  public step: number = 1

  public get title() {
    return this.tenant.id ? 'Edit Tenant' : 'New Tenant'
  }

  public get isEditing() {
    return !!this.$route.params.id
  }

  public get masks() {
    return {
      currencyMask,
    }
  }

  public get tenant_models() {
    return Tenant.models
  }

  public created() {
    if (this.$route.params.id && this.$route.params.id.length) {
      this.loadTenant()
    }
  }

  public async mounted() {
    if (!this.isEditing) {
      this.busy = false
      this.loading = false
    }

    this.tenant.databaseList().then(response => {
      this.databases = response.result.map((item: any) => new SelectOption(item, item))
    })
  }

  public saveTenant() {
    this.loading = true
    const id = this.isEditing ? this.$route.params.id : null
    this.tenant.save(id).then(response => {
      this.$router.push({ name: 'tenants' })
      this.loading = false
    })
  }

  public loadTenant() {
    this.loading = true
    Tenant.find(this.$route.params.id).then((response: Tenant) => {
      this.tenant = response
      this.loading = false
      this.busy = false
    })
  }

  public updateProgress(prevIndex: number, nextIndex: number) {
    if (nextIndex >= 0) {
      Vue.set(this, 'step', nextIndex + 1)
    }
  }

  public addTag(newTag: string) {
    if (!this.tenant.url_aliases) this.tenant.url_aliases = []
    this.tenant.url_aliases.push(newTag)
  }
}
